import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Radar = _resolveComponent("Radar")!

  return (_ctx.showChart)
    ? (_openBlock(), _createBlock(_component_Radar, {
        key: 0,
        data: _ctx.data,
        options: _ctx.options
      }, null, 8, ["data", "options"]))
    : _createCommentVNode("", true)
}